BaseManager = require 'BaseManager'
WebFont = require 'webFont'
log = require 'loglevel'

###############################################

class FontManager extends BaseManager

  name: 'FontManager'
  debug: true

  # -------------------------------------------

  loadFonts: (names, url, callback) ->
    log.info @name, 'loadFonts', names, url if @debug

    return callback true unless names?

    url = url + '?v=' + window.__version

    WebFont.load
      # google:
      #   families: names
      custom:
        families: names
        urls: [url]

      loading: =>
        log.info @name, 'loading ' + names if @debug

      active: =>
        log.info @name, 'success ' + names if @debug
        @renderFontOnce names
        callback true

      inactive: =>
        log.info @name, 'fail ' + names
        callback false

  # -------------------------------------------

  renderFontOnce: (names) ->

    tmp = []
    for name in names
      nameParts = name.split(':')

      if nameParts[1]?
        weights = nameParts[1].split(',')
        for weight in weights
          tmp.push nameParts[0] + "|" + weight[1]
      else
        tmp.push nameParts[0] + "|" + 4

    for name in tmp
      nameWeight = name.split('|')

      option =
        fontFamily: nameWeight[0]
        fontWeight: Number(nameWeight[1]+"00")

      new PIXI.Text 'test', option

      log.info @name, 'test', option if @debug

  # -------------------------------------------

module.exports = FontManager.getInstance()



// WEBPACK FOOTER //
// ./coffee/manager/font-manager.coffee